export const scouterSample = {
    'title': 'Elapsed time exceed a threshold.',
    'summary': '[/seoul-dev-configuration01/configuration-01] -1647223684(com.bg.common.service.messaging.JmsProducerService#sendMessage()) elapsed time(1407 ms) exceed a threshold.',
    'event_time': '1583834353129',
    'event_type': 'WARN',
    'type': 'TOMCAT',
    'resource_name': '/seoul-dev-configuration01/configuration-01',
    'urgency': 'high'
};



// WEBPACK FOOTER //
// ./src/app/views/main/integration/cstmSmry.sample/scouter.ts